/* Other product links load asynchronously. Keep them below purchase controls so
   their arrival cannot move Add to Cart out from under a customer's pointer. */
(() => {
  function positionRelatedChoices() {
    document.querySelectorAll('.main-product__blocks').forEach(blocks => {
      const buy = blocks.querySelector('.main-product__block-buy_buttons');
      if (!buy) return;
      blocks.querySelectorAll('.globo-product-groups-detail').forEach(group => {
        if (group.parentElement?.hasAttribute('data-janak-related-choices')) return;
        let host = blocks.querySelector('[data-janak-related-choices]');
        if (!host) {
          host = document.createElement('div');
          host.className = 'main-product__block';
          host.setAttribute('data-janak-related-choices', '');
          buy.after(host);
        }
        host.appendChild(group);
      });
    });
  }
  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    positionRelatedChoices();
    new MutationObserver(positionRelatedChoices).observe(main, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
